import script from "./HrContentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HrContentCard.vue?vue&type=script&setup=true&lang=js"

import "./HrContentCard.vue?vue&type=style&index=0&id=1c1d016a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c1d016a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
